import { useEffect } from "react";
import { commonActions, selectIsDarkMode } from "@shared/slices/common.slice";
import { localStorageService } from "utils/localStorageService";
import { useDispatch, useSelector } from "react-redux";
import { useMedia } from "react-use";

//todo: move this to shared, the only thing that might conflict between the platforms
//  is the usage of media query to get user system preference.
const useDarkMode = () => {
  const dispatch = useDispatch();
  const isDarkMode = useSelector(selectIsDarkMode);
  const userPrefersDarkMode = useMedia(`(prefers-color-scheme: dark)`, true);

  const setIsDarkMode = (isDarkMode: boolean) =>
    dispatch(commonActions.setIsDarkMode(isDarkMode));

  // This effect handles logout, which causes the state to reset and not correctly reload the isDarkMode flag
  // from localStorage
  useEffect(() => {
    const localStorageIsDarkMode = localStorageService.getIsDarkMode();
    if (localStorageIsDarkMode === undefined) {
      setIsDarkMode(userPrefersDarkMode);
    } else if (isDarkMode !== localStorageIsDarkMode) {
      setIsDarkMode(localStorageIsDarkMode);
    }
  }, [isDarkMode]);
};

export default useDarkMode;
